const riderReview = {
  backgroundColor: '$white',
};

export default riderReview;
